(function() {
  'use strict';

  window.WorldMapConfig = {

    /* ─── Tier colors ─── */
    colors: {
      tier1: '#d9c5a3',
      tier2: '#b9a58a',
      tier3: '#85735b',
      base:  '#2a2a2a',
      ocean: '#0f0f0f',
      stroke: '#0f0f0f',
      activeStroke: '#ffffff',
      coffeeBelt: 'rgba(255,255,255,0.045)'
    },

    /* ─── Coffee belt (Tropics) ─── */
    coffeeBelt: {
      north: 23.4366,
      south: -23.4366,
      show: true
    },

    /* ─── Legend ─── */
    legend: {
      title: 'Legende',
      items: [
        { marker: true, label: 'Kleinstadt-Herkunft' },
        { tier: 1, label: 'Top-Produzent',    color: '#d9c5a3' },
        { tier: 2, label: 'Großer Produzent', color: '#b9a58a' },
        { tier: 3, label: 'Produzent',         color: '#85735b' }
      ]
    },

    /* ─── Coffee-producing regions ─── */
    regions: {

      /* ── Tier 1 ── */
      BR: {
        tier: 1,
        title: 'Brasilien',
        description: 'Brasilien ist der weltweit größte Kaffeeproduzent und erzeugt rund ein Drittel des globalen Kaffees. Bekannt für nussige, schokoladige Aromen mit geringer Säure.',
        subRegions: [
          {
            name: 'Minas Gerais',
            description: 'Minas Gerais produziert rund 50 % des brasilianischen Kaffees. Die Teilregionen Cerrado, Sul de Minas und Chapada de Minas bieten unterschiedliche Terroirs mit nussigen, schokoladigen Profilen.',
            altitude: '800–1.400 m',
            varieties: 'Bourbon, Mundo Novo, Catuaí',
            process: 'Natural, Pulped Natural',
            harvest: 'Mai – September'
          },
          {
            name: 'São Paulo',
            description: 'Die Mogiana-Region in São Paulo ist eines der ältesten Anbaugebiete Brasiliens. Große Farmen mit mechanisierter Ernte erzeugen gleichmäßige, milde Kaffees.',
            altitude: '600–1.100 m',
            varieties: 'Mundo Novo, Catuaí, Icatu',
            process: 'Natural, Pulped Natural',
            harvest: 'Mai – August'
          },
          {
            name: 'Espírito Santo',
            description: 'Espírito Santo ist Brasiliens größter Robusta-Produzent (Conilon). In höheren Lagen wird zunehmend auch hochwertiger Arabica angebaut.',
            altitude: '400–1.200 m',
            varieties: 'Conilon (Robusta), Catuaí, Bourbon',
            process: 'Natural',
            harvest: 'Mai – August'
          },
          {
            name: 'Bahia',
            description: 'Das Chapada Diamantina-Hochplateau in Bahia ist ein aufstrebendes Spezialitäten-Anbaugebiet mit fruchtigen, komplexen Kaffees aus bewässertem Anbau.',
            altitude: '700–1.300 m',
            varieties: 'Catuaí, Catucaí, Obatã',
            process: 'Natural, Pulped Natural, Washed',
            harvest: 'Juni – September'
          },
          {
            name: 'Paraná',
            description: 'Paraná war historisch eines der wichtigsten Kaffeeanbaugebiete Brasiliens. Frostrisiken haben die Produktion reduziert, doch die Region liefert weiterhin solide, milde Kaffees.',
            altitude: '500–900 m',
            varieties: 'Mundo Novo, Catuaí, IAPAR 59',
            process: 'Natural',
            harvest: 'Mai – August'
          }
        ],
        stats: {
          rank: 1,
          production: '~55 Mio. Sack/Jahr',
          altitude: '600–1.400 m',
          varieties: 'Bourbon, Mundo Novo, Catuaí, Catuaba',
          process: 'Natural, Pulped Natural, Washed',
          harvest: 'Mai – September'
        },
        markerX: 275.0,
        markerY: 569.3
      },

      VN: {
        tier: 1,
        title: 'Vietnam',
        description: 'Vietnam ist der zweitgrößte Kaffeeproduzent der Welt und führt bei Robusta. Die Zentralhochland-Region produziert kräftigen, vollmundigen Kaffee.',
        subRegions: [
          {
            name: 'Zentralhochland (Tây Nguyên)',
            description: 'Das Zentralhochland ist das Herz des vietnamesischen Kaffeeanbaus. Die roten Basaltböden und das gemäßigte Klima auf 500–800 m bieten ideale Bedingungen für Robusta.',
            altitude: '500–800 m',
            varieties: 'Robusta, Catimor',
            process: 'Natural, Washed',
            harvest: 'Oktober – März'
          },
          {
            name: 'Đắk Lắk',
            description: 'Đắk Lắk ist die größte Kaffeeprovinz Vietnams und erzeugt allein rund 30 % der nationalen Produktion. Buôn Ma Thuột gilt als Kaffeehauptstadt des Landes.',
            altitude: '400–800 m',
            varieties: 'Robusta, Catimor',
            process: 'Natural, Honey',
            harvest: 'Oktober – Februar'
          },
          {
            name: 'Lam Đồng',
            description: 'Rund um die Stadt Đà Lạt auf über 1.000 m Höhe wächst zunehmend hochwertiger Arabica. Das kühlere Klima ermöglicht komplexere, fruchtigere Aromen.',
            altitude: '800–1.500 m',
            varieties: 'Arabica (Catimor, Bourbon), Robusta',
            process: 'Washed, Honey, Natural',
            harvest: 'November – März'
          },
          {
            name: 'Gia Lai',
            description: 'Gia Lai ist die zweitgrößte Kaffeeprovinz Vietnams. Großflächige Plantagen auf dem Basaltplateau produzieren vorwiegend kräftigen Robusta.',
            altitude: '400–800 m',
            varieties: 'Robusta, Catimor',
            process: 'Natural',
            harvest: 'Oktober – Februar'
          }
        ],
        stats: {
          rank: 2,
          production: '~30 Mio. Sack/Jahr',
          altitude: '500–1.500 m',
          varieties: 'Robusta, Catimor, Arabica (wachsend)',
          process: 'Natural, Washed',
          harvest: 'Oktober – April'
        },
        markerX: 661.2,
        markerY: 485.2
      },

      CO: {
        tier: 1,
        title: 'Kolumbien',
        description: 'Kolumbianischer Kaffee gilt als einer der besten der Welt. Das bergige Terrain und das tropische Klima schaffen ideale Anbaubedingungen für ausgewogene, fruchtige Arabica-Sorten.',
        subRegions: [
          {
            name: 'Huila',
            description: 'Huila ist Kolumbiens führende Spezialitätenregion. Die hohen Lagen und vulkanischen Böden erzeugen komplexe Kaffees mit Noten von tropischen Früchten und Karamell.',
            altitude: '1.200–2.000 m',
            varieties: 'Caturra, Colombia, Castillo',
            process: 'Washed, Natural, Honey',
            harvest: 'Haupternte: Okt–Jan, Mitaca: Apr–Jun'
          },
          {
            name: 'Nariño',
            description: 'Nariño an der Grenze zu Ecuador baut Kaffee in extremen Höhenlagen an. Die hohe UV-Strahlung und großen Temperaturschwankungen erzeugen ausgeprägte Süße und Komplexität.',
            altitude: '1.500–2.300 m',
            varieties: 'Caturra, Castillo, Typica',
            process: 'Washed',
            harvest: 'Mai – Juli'
          },
          {
            name: 'Antioquia',
            description: 'Antioquia ist eines der traditionsreichsten Kaffeegebiete Kolumbiens. Die Paisa-Kaffeebauern erzeugen ausgewogene, nussige Kaffees mit mittlerer Säure.',
            altitude: '1.300–1.800 m',
            varieties: 'Caturra, Colombia, Castillo',
            process: 'Washed',
            harvest: 'Okt–Jan, Mitaca: Apr–Jun'
          },
          {
            name: 'Tolima',
            description: 'Tolima gewinnt zunehmend an Anerkennung in der Spezialitätenszene. Kleinbauern in abgelegenen Bergregionen produzieren fruchtige, blumige Kaffees.',
            altitude: '1.400–2.000 m',
            varieties: 'Caturra, Castillo, Typica, Bourbon',
            process: 'Washed, Honey',
            harvest: 'Okt–Jan, Mitaca: Apr–Jun'
          },
          {
            name: 'Cauca',
            description: 'Caucas hohe Lagen auf dem Meseta de Popayán bieten ein einzigartiges Mikroklima. Die Kaffees zeichnen sich durch helle Säure und ausgeprägte Fruchtnoten aus.',
            altitude: '1.600–2.100 m',
            varieties: 'Caturra, Castillo, Colombia',
            process: 'Washed',
            harvest: 'Okt–Jan, Mitaca: Apr–Jun'
          },
          {
            name: 'Eje Cafetero',
            description: 'Die Kaffeeachse (Caldas, Risaralda, Quindío) ist das Herz der kolumbianischen Kaffeekultur und UNESCO-Weltkulturerbe. Traditioneller Anbau erzeugt ausgewogene, milde Kaffees.',
            altitude: '1.200–1.800 m',
            varieties: 'Caturra, Castillo, Colombia',
            process: 'Washed',
            harvest: 'Okt–Dez, Mitaca: Apr–Jun'
          }
        ],
        stats: {
          rank: 3,
          production: '~14 Mio. Sack/Jahr',
          altitude: '1.200–2.000 m',
          varieties: 'Caturra, Castillo, Colombia, Typica',
          process: 'Washed (vorwiegend)',
          harvest: 'Haupternte: Okt–Jan, Mitaca: Apr–Jun'
        },
        markerX: 228.0,
        markerY: 520.7
      },

      ET: {
        tier: 1,
        title: 'Äthiopien',
        description: 'Äthiopien ist die Wiege des Arabica-Kaffees. Wildwachsende Kaffeearten in den Bergwäldern bieten eine unvergleichliche Vielfalt an blumigen und fruchtigen Aromen.',
        subRegions: [
          {
            name: 'Yirgacheffe',
            description: 'Yirgacheffe gilt als Kronjuwel äthiopischen Kaffees. Die gewaschenen Kaffees sind weltberühmt für ihre jasminartigen Blütenaromen und zitrusartige Säure.',
            altitude: '1.700–2.200 m',
            varieties: 'Heirloom (JARC 74110, 74112, Dega)',
            process: 'Washed, Natural',
            harvest: 'Oktober – Januar'
          },
          {
            name: 'Sidamo',
            description: 'Sidamo (heute Sidama) produziert vielfältige Kaffees mit beerigen Noten und mittlerer Säure. Natural-Aufbereitungen zeigen intensive Blaubeer- und Erdbeeraromen.',
            altitude: '1.500–2.200 m',
            varieties: 'Heirloom-Sorten',
            process: 'Washed, Natural',
            harvest: 'Oktober – Februar'
          },
          {
            name: 'Guji',
            description: 'Guji wurde erst kürzlich als eigenständige Region anerkannt. Die abgelegenen Hochlagen erzeugen komplexe Kaffees mit ausgeprägter Süße und Steinobstnoten.',
            altitude: '1.800–2.300 m',
            varieties: 'Heirloom-Sorten',
            process: 'Washed, Natural',
            harvest: 'November – Februar'
          },
          {
            name: 'Harrar',
            description: 'Harrar im Osten Äthiopiens ist bekannt für seine natural-aufbereiteten Kaffees mit wilden, weinigen Fruchtaromen und einer charakteristischen Blaubeer-Note.',
            altitude: '1.500–2.100 m',
            varieties: 'Heirloom-Sorten (Harrar-Landrassen)',
            process: 'Natural (vorwiegend)',
            harvest: 'November – Februar'
          },
          {
            name: 'Limu',
            description: 'Limu im Westen Äthiopiens produziert gewaschene Kaffees mit weiniger Säure, mittlerem Körper und würzigen Noten. Eine geschätzte, aber weniger bekannte Herkunft.',
            altitude: '1.400–2.000 m',
            varieties: 'Heirloom-Sorten',
            process: 'Washed',
            harvest: 'November – Januar'
          },
          {
            name: 'Jimma',
            description: 'Die Region Jimma (Kaffa) gilt als Ursprung des Kaffees. Waldkaffee von wildwachsenden Bäumen bietet einzigartige, erdige und würzige Geschmacksprofile.',
            altitude: '1.400–2.000 m',
            varieties: 'Heirloom (wilde Waldvarietäten)',
            process: 'Natural, Washed',
            harvest: 'Oktober – Januar'
          }
        ],
        stats: {
          rank: 5,
          production: '~7,5 Mio. Sack/Jahr',
          altitude: '1.500–2.200 m',
          varieties: 'Heirloom-Sorten (JARC 74110, 74112, u.a.)',
          process: 'Washed, Natural',
          harvest: 'Oktober – Februar'
        },
        markerX: 505.9,
        markerY: 508.5
      },

      /* ── Tier 2 ── */
      ID: {
        tier: 2,
        title: 'Indonesien',
        description: 'Indonesien produziert einzigartige, erdig-würzige Kaffees. Sumatra, Java und Sulawesi bieten jeweils eigene Geschmacksprofile.',
        subRegions: [
          {
            name: 'Sumatra (Mandheling, Lintong)',
            description: 'Sumatras Kaffees sind weltbekannt für ihren vollen Körper, erdige Aromen und niedrige Säure. Die traditionelle Giling-Basah-Aufbereitung verleiht ihnen ein unverwechselbares Profil.',
            altitude: '800–1.600 m',
            varieties: 'Typica, Catimor, Tim-Tim, Ateng',
            process: 'Wet-Hulled (Giling Basah)',
            harvest: 'Ganzjährig (Haupternte: Okt–Mär)'
          },
          {
            name: 'Java',
            description: 'Java hat eine über 300-jährige Kaffeetradition. Die staatlichen Plantagen (PTP) erzeugen saubere, ausgewogene Kaffees mit würzigen und kräuterigen Noten.',
            altitude: '900–1.500 m',
            varieties: 'Typica, S-Linien (S795), Catimor',
            process: 'Washed, Wet-Hulled',
            harvest: 'Juli – September'
          },
          {
            name: 'Sulawesi (Toraja)',
            description: 'Die Toraja-Highlands auf Sulawesi erzeugen komplexe Kaffees mit vielschichtigen Gewürzaromen, dunkler Frucht und einem seidigen Mundgefühl.',
            altitude: '1.100–1.800 m',
            varieties: 'S-Linien (S795), Typica, Catimor',
            process: 'Wet-Hulled, Washed',
            harvest: 'Mai – November'
          },
          {
            name: 'Flores',
            description: 'Die kleine Insel Flores produziert überraschend saubere, süße Kaffees mit Noten von dunkler Schokolade und Gewürzen. Der vulkanische Boden verleiht mineralische Tiefe.',
            altitude: '1.200–1.800 m',
            varieties: 'Typica, Catimor, Jember',
            process: 'Wet-Hulled, Washed, Natural',
            harvest: 'Mai – September'
          },
          {
            name: 'Bali',
            description: 'Bali produziert in kleinem Maßstab überwiegend Bio-Kaffee auf den Hängen des Vulkans Kintamani. Die Kaffees sind hell, fruchtig und haben eine angenehme Zitrus-Säure.',
            altitude: '900–1.500 m',
            varieties: 'Typica, Catimor',
            process: 'Wet-Hulled, Washed',
            harvest: 'Mai – Oktober'
          }
        ],
        stats: {
          rank: 4,
          production: '~10 Mio. Sack/Jahr',
          altitude: '800–1.800 m',
          varieties: 'Typica, Catimor, S-Linien, Robusta',
          process: 'Wet-Hulled (Giling Basah), Washed, Natural',
          harvest: 'Mai – September (Sumatra ganzjährig)'
        },
        markerX: 695.3,
        markerY: 537.9
      },

      HN: {
        tier: 2,
        title: 'Honduras',
        description: 'Honduras hat sich zu einem der Top-Kaffeeproduzenten Mittelamerikas entwickelt. Die vielfältigen Mikroklimate ermöglichen komplexe, fruchtige Kaffees.',
        subRegions: [
          {
            name: 'Copan',
            description: 'Copan im Westen Honduras\' produziert Kaffees mit schokoladigen, karamelligen Noten und mittlerer Säure. Die Region ist für konsistente Qualität bekannt.',
            altitude: '1.000–1.500 m',
            varieties: 'Catuaí, Lempira, IHCAFE 90',
            process: 'Washed, Honey',
            harvest: 'November – März'
          },
          {
            name: 'Lempira',
            description: 'Lempira erzeugt zunehmend prämierte Spezialitätenkaffees. Die hohen Lagen und das kühle Klima begünstigen langsame Reifung und komplexe Fruchtaromen.',
            altitude: '1.100–1.700 m',
            varieties: 'Catuaí, Lempira, Parainema',
            process: 'Washed, Natural',
            harvest: 'November – März'
          },
          {
            name: 'Santa Bárbara',
            description: 'Santa Bárbara ist eine der höchstgelegenen Kaffeeregionen Honduras\' und bekannt für ihre hellen, fruchtigen Kaffees mit blumigen Noten.',
            altitude: '1.100–1.800 m',
            varieties: 'Catuaí, Caturra, Pacas',
            process: 'Washed, Honey, Natural',
            harvest: 'Dezember – April'
          },
          {
            name: 'Comayagua',
            description: 'Im zentralen Hochland von Comayagua wachsen ausgewogene Kaffees mit nussigen Aromen und sanfter Säure. Die Region profitiert von gleichmäßigen Temperaturen.',
            altitude: '1.000–1.500 m',
            varieties: 'Catuaí, Caturra, Lempira',
            process: 'Washed',
            harvest: 'November – März'
          },
          {
            name: 'Opalaca',
            description: 'Opalaca ist eine abgelegene, schwer zugängliche Region, die einige der höchstbewerteten Kaffees Honduras\' hervorbringt — mit komplexer Frucht und lebhafter Säure.',
            altitude: '1.200–1.800 m',
            varieties: 'Catuaí, Caturra, Pacas',
            process: 'Washed, Natural',
            harvest: 'Dezember – April'
          }
        ],
        stats: {
          rank: 6,
          production: '~7 Mio. Sack/Jahr',
          altitude: '1.100–1.600 m',
          varieties: 'Catuai, Caturra, Lempira, IHCAFE 90',
          process: 'Washed, Natural, Honey',
          harvest: 'November – April'
        },
        markerX: 198.3,
        markerY: 493.3
      },

      IN: {
        tier: 2,
        title: 'Indien',
        description: 'Indischer Kaffee wächst häufig im Schatten von Gewürzbäumen, was den Bohnen einzigartige würzige Noten verleiht. Monsooned Malabar ist eine berühmte Spezialität.',
        subRegions: [
          {
            name: 'Karnataka (Chikmagalur, Coorg)',
            description: 'Karnataka erzeugt über 70 % des indischen Kaffees. In Chikmagalur und Coorg wachsen die Bohnen unter Gewürz- und Schattenbäumen, was ihnen würzige, schokoladige Noten verleiht.',
            altitude: '900–1.500 m',
            varieties: 'SLN 795, S.274, Catimor, Robusta',
            process: 'Washed, Natural, Monsooned',
            harvest: 'November – Februar'
          },
          {
            name: 'Kerala (Wayanad)',
            description: 'Wayanad in Kerala ist ein üppiges Regenwaldgebiet. Der Kaffee wächst zwischen Pfeffer, Kardamom und Vanille — diese Nachbarschaft verleiht den Bohnen subtile Gewürznoten.',
            altitude: '700–1.200 m',
            varieties: 'Robusta, SLN 795, Catimor',
            process: 'Washed, Natural',
            harvest: 'November – Februar'
          },
          {
            name: 'Tamil Nadu (Nilgiris)',
            description: 'Die Nilgiris (Blaue Berge) in Tamil Nadu bieten kühle Höhenlagen für hochwertigen Arabica. Die Kaffees zeigen helle Säure, mittleren Körper und blumige Noten.',
            altitude: '1.000–1.600 m',
            varieties: 'SLN 795, Catimor, S.274',
            process: 'Washed, Natural',
            harvest: 'Dezember – März'
          }
        ],
        stats: {
          rank: 7,
          production: '~5,5 Mio. Sack/Jahr',
          altitude: '900–1.500 m',
          varieties: 'SLN 795, Catimor, S.274, Robusta',
          process: 'Washed, Natural, Monsooned',
          harvest: 'November – Februar'
        },
        markerX: 601.9,
        markerY: 472.6
      },

      GT: {
        tier: 2,
        title: 'Guatemala',
        description: 'Guatemala bietet durch seine vulkanischen Böden und Höhenlagen hervorragende Bedingungen für Spezialitätenkaffee mit vollmundigem, schokoladigem Profil.',
        subRegions: [
          {
            name: 'Antigua',
            description: 'Antigua ist von drei Vulkanen umgeben und erzeugt vollmundige, rauchige Kaffees mit schokoladiger Süße und mittlerer Säure. Ein Klassiker unter den Guatemala-Kaffees.',
            altitude: '1.500–1.700 m',
            varieties: 'Bourbon, Caturra, Catuaí',
            process: 'Washed',
            harvest: 'Dezember – März'
          },
          {
            name: 'Huehuetenango',
            description: 'Huehuetenango ist Guatemalas höchstgelegene und renommierteste Anbauregion. Trockene, heiße Winde aus Mexiko schützen die Pflanzen vor Frost und ermöglichen Anbau bis 2.000 m.',
            altitude: '1.500–2.000 m',
            varieties: 'Bourbon, Caturra, Typica, Pache',
            process: 'Washed, Natural, Honey',
            harvest: 'Januar – April'
          },
          {
            name: 'Atitlán',
            description: 'Am Ufer des Atitlán-Sees gelegen, erzeugt diese vulkanische Region Kaffees mit lebhafter Zitrus-Säure, blumigen Noten und einem klaren, sauberen Abgang.',
            altitude: '1.500–1.800 m',
            varieties: 'Bourbon, Typica, Caturra',
            process: 'Washed',
            harvest: 'Dezember – März'
          },
          {
            name: 'Cobán',
            description: 'Cobán ist eine der regenreichsten Kaffeeregionen der Welt. Die konstante Feuchtigkeit und kühlen Temperaturen erzeugen würzige, kräuterige Kaffees mit mittlerem Körper.',
            altitude: '1.300–1.500 m',
            varieties: 'Bourbon, Pache, Catuaí',
            process: 'Washed',
            harvest: 'Dezember – März'
          },
          {
            name: 'Fraijanes',
            description: 'Die Fraijanes-Region profitiert von nährstoffreichen vulkanischen Böden und produziert ausgewogene Kaffees mit Noten von Schokolade, Steinobst und einer lebhaften Säure.',
            altitude: '1.400–1.800 m',
            varieties: 'Bourbon, Caturra, Catuaí',
            process: 'Washed, Honey',
            harvest: 'Dezember – März'
          }
        ],
        stats: {
          rank: 10,
          production: '~3,5 Mio. Sack/Jahr',
          altitude: '1.300–1.800 m',
          varieties: 'Bourbon, Caturra, Catuai, Pache',
          process: 'Washed (vorwiegend), Natural, Honey',
          harvest: 'Dezember – März'
        },
        markerX: 188.6,
        markerY: 488.7
      },

      UG: {
        tier: 2,
        title: 'Uganda',
        description: 'Uganda ist Afrikas größter Kaffee-Exporteur und produziert sowohl robuste Robustas als auch feine Arabicas aus den Bergregionen am Ruwenzori.',
        subRegions: [
          {
            name: 'Mount Elgon',
            description: 'An den Hängen des Mount Elgon im Osten Ugandas wachsen helle, zitrusartige Arabica-Kaffees. Die vulkanischen Böden und gleichmäßige Niederschläge sorgen für hohe Qualität.',
            altitude: '1.500–2.000 m',
            varieties: 'SL14, SL28, Typica',
            process: 'Washed, Natural',
            harvest: 'Oktober – Februar'
          },
          {
            name: 'Rwenzori',
            description: 'Die Rwenzori-Berge ("Mondberge") im Westen bieten extreme Höhenlagen für langsam gereiften Arabica mit komplexen, fruchtigen Aromen und ausgewogener Säure.',
            altitude: '1.400–2.200 m',
            varieties: 'SL14, SL28, Nyasaland',
            process: 'Washed',
            harvest: 'September – Januar'
          },
          {
            name: 'West-Nil',
            description: 'Die West-Nil-Region produziert vorwiegend Robusta mit zunehmendem Arabica-Anbau. Die flacheren Lagen erzeugen kräftige, erdige Kaffees mit vollem Körper.',
            altitude: '800–1.500 m',
            varieties: 'Robusta (Nganda, Erecta), SL14',
            process: 'Natural, Washed',
            harvest: 'Oktober – Januar'
          },
          {
            name: 'Bugisu',
            description: 'Die Bugisu-Region am westlichen Hang des Mount Elgon ist bekannt für ihre hellen, weinigen Kaffees mit prägnanter Säure und beerigen Noten.',
            altitude: '1.500–2.000 m',
            varieties: 'SL14, SL28',
            process: 'Washed',
            harvest: 'Oktober – Februar'
          }
        ],
        stats: {
          rank: 8,
          production: '~5 Mio. Sack/Jahr',
          altitude: '1.200–2.000 m (Arabica)',
          varieties: 'SL14, SL28, Robusta (Nganda, Erecta)',
          process: 'Washed, Natural',
          harvest: 'Oktober – Februar (Haupternte)'
        },
        markerX: 486.4,
        markerY: 528.2
      },

      MX: {
        tier: 2,
        title: 'Mexiko',
        description: 'Mexiko erzeugt leichten, säurebetonten Kaffee, häufig aus Bio- und Fair-Trade-Anbau. Chiapas und Oaxaca sind die Hauptanbaugebiete.',
        subRegions: [
          {
            name: 'Chiapas',
            description: 'Chiapas an der Grenze zu Guatemala ist Mexikos größte und wichtigste Kaffeeregion. Die Sierra Madre erzeugt helle, saubere Kaffees mit Noten von Schokolade und Nüssen.',
            altitude: '900–1.700 m',
            varieties: 'Typica, Bourbon, Caturra, Marsellesa',
            process: 'Washed',
            harvest: 'November – März'
          },
          {
            name: 'Oaxaca',
            description: 'In den Bergen von Oaxaca wächst der berühmte Pluma-Kaffee. Kleinbauern erzeugen hier mild-fruchtige, ausgewogene Kaffees mit sanfter Säure und schokoladigen Noten.',
            altitude: '900–1.600 m',
            varieties: 'Typica (Pluma Hidalgo), Bourbon, Caturra',
            process: 'Washed',
            harvest: 'Dezember – März'
          },
          {
            name: 'Veracruz',
            description: 'Veracruz an der Golfküste produziert Kaffee in mittleren Höhenlagen. Die Kaffees sind mild, nussig und haben eine geringe Säure — ideal für Blends.',
            altitude: '800–1.400 m',
            varieties: 'Typica, Caturra, Garnica',
            process: 'Washed',
            harvest: 'November – März'
          },
          {
            name: 'Puebla',
            description: 'In der Sierra Norte von Puebla wird traditioneller Schattenkaffee angebaut. Indigene Gemeinden erzeugen hier häufig biologisch zertifizierte, milde Kaffees.',
            altitude: '800–1.400 m',
            varieties: 'Typica, Bourbon, Mundo Novo',
            process: 'Washed',
            harvest: 'November – März'
          },
          {
            name: 'Guerrero',
            description: 'Guerrero ist ein aufstrebendes Anbaugebiet, das zunehmend Spezialitätenkaffee produziert. Kleinbauern in abgelegenen Bergdörfern erzeugen hier charaktervolle Kaffees.',
            altitude: '900–1.500 m',
            varieties: 'Typica, Bourbon, Caturra',
            process: 'Washed',
            harvest: 'November – März'
          }
        ],
        stats: {
          rank: 9,
          production: '~4 Mio. Sack/Jahr',
          altitude: '900–1.700 m',
          varieties: 'Typica, Bourbon, Caturra, Mundo Novo',
          process: 'Washed (vorwiegend)',
          harvest: 'November – März'
        },
        markerX: 166.7,
        markerY: 462.2
      },

      /* ── Tier 3 ── */
      PE: {
        tier: 3,
        title: 'Peru',
        description: 'Peru ist ein aufstrebender Spezialitätenkaffee-Produzent. Die Andenhochlagen erzeugen milde, blumige Kaffees, oft aus biologischem Anbau.',
        subRegions: [
          {
            name: 'Cajamarca',
            description: 'Cajamarca im Norden Perus ist die größte Kaffeeregion des Landes. Die Andenhänge erzeugen vielfältige Kaffees mit Noten von Steinobst, Karamell und Zitrus.',
            altitude: '1.200–1.900 m',
            varieties: 'Typica, Caturra, Bourbon, Catimor',
            process: 'Washed',
            harvest: 'Juni – September'
          },
          {
            name: 'San Martín',
            description: 'San Martín am östlichen Andenabhang ist eine wachsende Kaffeeregion. Die üppige Vegetation und fruchtbaren Böden erzeugen milde, süße Kaffees mit schokoladigen Noten.',
            altitude: '1.000–1.600 m',
            varieties: 'Caturra, Catimor, Typica',
            process: 'Washed',
            harvest: 'April – August'
          },
          {
            name: 'Amazonas',
            description: 'Die Region Amazonas produziert zunehmend hochwertigen Spezialitätenkaffee. Die abgelegenen Hochlagen in der Nebelwaldzone erzeugen einzigartige, blumig-fruchtige Profile.',
            altitude: '1.400–2.000 m',
            varieties: 'Typica, Bourbon, Caturra',
            process: 'Washed, Natural',
            harvest: 'Mai – September'
          },
          {
            name: 'Junín',
            description: 'In Junín im zentralen Peru wächst Kaffee in der Selva-Central-Region. Die tropischen Bergwälder erzeugen ausgewogene Kaffees mit nussigen und schokoladigen Aromen.',
            altitude: '1.200–1.800 m',
            varieties: 'Typica, Caturra, Catimor',
            process: 'Washed',
            harvest: 'April – August'
          },
          {
            name: 'Cusco',
            description: 'In der historischen Region Cusco wächst Kaffee in der Quillabamba-Senke. Die extremen Höhenlagen erzeugen komplexe, blumige Kaffees mit heller Säure.',
            altitude: '1.400–2.000 m',
            varieties: 'Typica, Bourbon, Caturra',
            process: 'Washed',
            harvest: 'Mai – September'
          }
        ],
        stats: {
          rank: 11,
          production: '~3 Mio. Sack/Jahr',
          altitude: '1.200–1.800 m',
          varieties: 'Typica, Caturra, Bourbon, Catimor',
          process: 'Washed (vorwiegend)',
          harvest: 'April – September'
        },
        markerX: 224.3,
        markerY: 558.0
      },

      KE: {
        tier: 3,
        title: 'Kenia',
        description: 'Kenianischer Kaffee ist bekannt für intensive, komplexe Säure mit Noten von Schwarzer Johannisbeere und Zitrusfrüchten. Das Auktionssystem sichert hohe Qualität.',
        subRegions: [
          {
            name: 'Mount Kenya',
            description: 'Die Hänge des Mount Kenya bieten ideale Höhenlagen und vulkanische Böden. Die Kaffees sind intensiv, komplex und zeigen klassische kenianische Johannisbeer- und Zitrusnoten.',
            altitude: '1.400–2.000 m',
            varieties: 'SL28, SL34, Ruiru 11, Batian',
            process: 'Washed (Double Washed)',
            harvest: 'Oktober – Dezember'
          },
          {
            name: 'Nyeri',
            description: 'Nyeri gilt als eine der besten Kaffeeregionen der Welt. Die tiefroten Vulkanböden und kühlen Temperaturen erzeugen Kaffees mit explosiver Säure und Tomatennoten.',
            altitude: '1.600–2.100 m',
            varieties: 'SL28, SL34, Ruiru 11',
            process: 'Washed (Double Washed)',
            harvest: 'Oktober – Dezember'
          },
          {
            name: 'Kiambu',
            description: 'Kiambu nahe Nairobi ist eines der historischen Kaffeegebiete Kenias. Die alten Plantagen erzeugen vollmundige Kaffees mit schokoladigen und beerigen Noten.',
            altitude: '1.500–1.800 m',
            varieties: 'SL28, SL34, K7',
            process: 'Washed',
            harvest: 'Oktober – Dezember'
          },
          {
            name: 'Kirinyaga',
            description: 'Kirinyaga an der Südostflanke des Mount Kenya erzeugt helle, komplexe Kaffees. Kleinbauern-Kooperativen produzieren hier einige der höchstbewerteten kenianischen Lots.',
            altitude: '1.600–2.000 m',
            varieties: 'SL28, SL34, Batian',
            process: 'Washed (Double Washed)',
            harvest: 'Oktober – Dezember'
          },
          {
            name: 'Embu',
            description: 'Embu an den östlichen Hängen des Mount Kenya produziert ausgewogene, saubere Kaffees mit mittlerer Säure und Noten von roten Beeren und Zitrus.',
            altitude: '1.400–1.800 m',
            varieties: 'SL28, SL34, Ruiru 11',
            process: 'Washed',
            harvest: 'Oktober – Dezember'
          }
        ],
        stats: {
          rank: 16,
          production: '~0,8 Mio. Sack/Jahr',
          altitude: '1.400–2.100 m',
          varieties: 'SL28, SL34, Ruiru 11, Batian',
          process: 'Washed (Double Washed)',
          harvest: 'Oktober – Dezember (Haupternte)'
        },
        markerX: 499.6,
        markerY: 530.0
      },

      CR: {
        tier: 3,
        title: 'Costa Rica',
        description: 'Costa Rica produziert ausschließlich Arabica und ist für saubere, helle Kaffees mit brillanter Säure bekannt. Honey Processing ist hier weit verbreitet.',
        subRegions: [
          {
            name: 'Tarrazú',
            description: 'Tarrazú ist Costa Ricas berühmteste Kaffeeregion. Die hohen Lagen und die scharfe Trockenzeit erzeugen helle, saubere Kaffees mit lebhafter Säure und Zitrusnoten.',
            altitude: '1.200–1.900 m',
            varieties: 'Caturra, Catuaí, Villa Sarchí',
            process: 'Washed, Honey',
            harvest: 'Dezember – März'
          },
          {
            name: 'Central Valley',
            description: 'Das Zentraltal um San José ist das historische Herz des costa-ricanischen Kaffeeanbaus. Moderate Höhenlagen erzeugen ausgewogene, milde Kaffees mit schokoladigen Noten.',
            altitude: '1.000–1.400 m',
            varieties: 'Caturra, Catuaí',
            process: 'Washed, Honey',
            harvest: 'November – März'
          },
          {
            name: 'West Valley',
            description: 'Das West Valley bietet vielfältige Mikroklimate und ist ein Zentrum innovativer Aufbereitungsmethoden. Viele Cup-of-Excellence-Gewinner stammen aus dieser Region.',
            altitude: '1.200–1.700 m',
            varieties: 'Caturra, Catuaí, Villa Sarchí, Geisha',
            process: 'Honey, Washed, Natural, Anaerobic',
            harvest: 'Dezember – März'
          },
          {
            name: 'Brunca',
            description: 'Die südliche Brunca-Region nahe der Grenze zu Panama produziert zunehmend hochwertige Kaffees. Die abgelegene Lage bewahrt traditionelle Anbaumethoden.',
            altitude: '800–1.500 m',
            varieties: 'Caturra, Catuaí, Obatã',
            process: 'Washed, Honey',
            harvest: 'November – März'
          },
          {
            name: 'Tres Ríos',
            description: 'Tres Ríos ist eine der kleinsten und exklusivsten Kaffeeregionen Costa Ricas. Die vulkanischen Böden und das konstante Klima erzeugen elegante, filigrane Kaffees.',
            altitude: '1.200–1.500 m',
            varieties: 'Caturra, Catuaí',
            process: 'Washed',
            harvest: 'Dezember – März'
          }
        ],
        stats: {
          rank: 15,
          production: '~1,5 Mio. Sack/Jahr',
          altitude: '1.200–1.800 m',
          varieties: 'Caturra, Catuai, Villa Sarchí',
          process: 'Honey, Washed, Natural',
          harvest: 'November – März'
        },
        markerX: 201.1,
        markerY: 506.3
      },

      TZ: {
        tier: 3,
        title: 'Tansania',
        description: 'Tansanischer Kaffee vom Kilimandscharo und aus der Südregion bietet helle Säure und fruchtige Noten, ähnlich wie kenianischer Kaffee.',
        subRegions: [
          {
            name: 'Kilimandscharo',
            description: 'An den Hängen des Kilimandscharo wächst Tansanias berühmtester Kaffee. Die vulkanischen Böden und kühlen Nachttemperaturen erzeugen helle, weinige Kaffees mit Beerennoten.',
            altitude: '1.400–2.000 m',
            varieties: 'Bourbon, Kent, N39',
            process: 'Washed',
            harvest: 'Juli – Dezember'
          },
          {
            name: 'Arusha',
            description: 'Die Region Arusha am Mount Meru produziert Kaffees mit lebhafter Säure und Zitrusnoten. Die Nähe zum Kilimandscharo sorgt für ähnlich ideale Anbaubedingungen.',
            altitude: '1.400–1.800 m',
            varieties: 'Bourbon, Kent, Typica',
            process: 'Washed',
            harvest: 'Juli – Dezember'
          },
          {
            name: 'Mbeya',
            description: 'Die südlichen Highlands um Mbeya sind ein wachsendes Anbaugebiet. Kleinbauern erzeugen hier fruchtige, saubere Kaffees mit mittlerer Säure und schokoladigen Untertönen.',
            altitude: '1.500–2.000 m',
            varieties: 'Bourbon, Kent, Typica',
            process: 'Washed, Natural',
            harvest: 'Juni – Oktober'
          },
          {
            name: 'Ruvuma',
            description: 'Ruvuma an der Grenze zu Mosambik ist ein aufstrebendes Kaffeegebiet. Die Region produziert zunehmend hochwertigen Arabica mit blumigen und nussigen Aromen.',
            altitude: '1.300–1.700 m',
            varieties: 'Bourbon, N39',
            process: 'Washed',
            harvest: 'Juli – November'
          },
          {
            name: 'Kigoma',
            description: 'Kigoma am Tanganjikasee ist bekannt für seinen Robusta und zunehmend auch Arabica. Die tropische Lage erzeugt kräftige, erdige Kaffees mit niedrigerer Säure.',
            altitude: '1.000–1.500 m',
            varieties: 'Robusta, Bourbon',
            process: 'Washed, Natural',
            harvest: 'Juli – Oktober'
          }
        ],
        stats: {
          rank: 17,
          production: '~0,8 Mio. Sack/Jahr',
          altitude: '1.400–2.000 m',
          varieties: 'Bourbon, Kent, Typica, N39',
          process: 'Washed, Natural',
          harvest: 'Juli – Dezember'
        },
        markerX: 492.7,
        markerY: 546.7
      },

      RW: {
        tier: 3,
        title: 'Ruanda',
        description: 'Ruanda, das "Land der tausend Hügel", produziert zunehmend exzellente Spezialitätenkaffees mit blumigen, zitrusartigen Noten.',
        subRegions: [
          {
            name: 'Nyamasheke',
            description: 'Nyamasheke am Kivu-See im Westen Ruandas erzeugt komplexe Kaffees mit fruchtigen Noten und einem seidigen Körper. Die hohe Luftfeuchtigkeit begünstigt gleichmäßige Reifung.',
            altitude: '1.500–2.000 m',
            varieties: 'Red Bourbon, BM139',
            process: 'Washed',
            harvest: 'März – Juli'
          },
          {
            name: 'Huye',
            description: 'Huye im Süden Ruandas ist Sitz des renommierten Huye Mountain Washing Station. Die hohen Lagen erzeugen helle, komplexe Kaffees mit Zitrus- und Blütenaromen.',
            altitude: '1.600–2.000 m',
            varieties: 'Red Bourbon',
            process: 'Washed',
            harvest: 'März – Juni'
          },
          {
            name: 'Gakenke',
            description: 'Gakenke in der Nordprovinz liegt auf fruchtbarem vulkanischem Boden. Die Region erzeugt reichhaltige, vollmundige Kaffees mit Noten von Karamell und tropischen Früchten.',
            altitude: '1.500–1.900 m',
            varieties: 'Red Bourbon, BM71',
            process: 'Washed, Natural',
            harvest: 'März – Juli'
          },
          {
            name: 'Rusizi',
            description: 'Rusizi im Südwesten profitiert von der Nähe zum Kivu-See. Die moderaten Temperaturen und reichlichen Niederschläge erzeugen süße, fruchtige Kaffees mit mittlerer Säure.',
            altitude: '1.400–1.800 m',
            varieties: 'Red Bourbon, BM139',
            process: 'Washed',
            harvest: 'März – Juli'
          },
          {
            name: 'Kayonza',
            description: 'Kayonza in der Ostprovinz ist ein neueres Kaffeeanbaugebiet. Die trockeneren Bedingungen erzeugen ausgewogene, nussige Kaffees mit moderater Säure.',
            altitude: '1.400–1.700 m',
            varieties: 'Red Bourbon',
            process: 'Washed',
            harvest: 'März – Juli'
          }
        ],
        stats: {
          rank: 20,
          production: '~0,3 Mio. Sack/Jahr',
          altitude: '1.500–2.000 m',
          varieties: 'Red Bourbon, BM139, BM71',
          process: 'Washed (vorwiegend), Natural',
          harvest: 'März – Juli'
        },
        markerX: 480.4,
        markerY: 535.3
      },

      PG: {
        tier: 3,
        title: 'Papua-Neuguinea',
        description: 'PNG erzeugt vollmundige, erdige Kaffees mit fruchtigen Noten. Der Anbau erfolgt meist durch Kleinbauern in den Highlands.',
        subRegions: [
          {
            name: 'Eastern Highlands',
            description: 'Die Eastern Highlands (Goroka-Tal) sind das größte Anbaugebiet PNGs. Kleinbauern erzeugen hier vollmundige Kaffees mit erdigen, würzigen Noten und tropischer Frucht.',
            altitude: '1.300–1.900 m',
            varieties: 'Typica, Bourbon, Arusha',
            process: 'Washed, Semi-Washed',
            harvest: 'April – August'
          },
          {
            name: 'Western Highlands',
            description: 'Die Western Highlands um Mount Hagen produzieren saubere, fruchtige Kaffees. Die größeren Plantagen dieser Region sorgen für konsistentere Qualität als andere Gebiete.',
            altitude: '1.400–1.800 m',
            varieties: 'Typica, Bourbon, Arusha',
            process: 'Washed',
            harvest: 'April – September'
          },
          {
            name: 'Simbu',
            description: 'Simbu (Chimbu) liegt in extremen Höhenlagen und produziert komplexe, helle Kaffees mit floralen Noten. Die abgelegene Lage macht den Transport herausfordernd.',
            altitude: '1.500–2.000 m',
            varieties: 'Typica, Bourbon',
            process: 'Washed',
            harvest: 'April – August'
          },
          {
            name: 'Jiwaka',
            description: 'Jiwaka ist die jüngste Provinz PNGs und eine aufstrebende Kaffeeregion. Die fruchtbaren Vulkanböden und idealen Höhenlagen versprechen wachsendes Potenzial für Spezialitätenkaffee.',
            altitude: '1.400–1.800 m',
            varieties: 'Typica, Bourbon, Arusha',
            process: 'Washed, Semi-Washed',
            harvest: 'April – September'
          }
        ],
        stats: {
          rank: 18,
          production: '~0,7 Mio. Sack/Jahr',
          altitude: '1.300–1.900 m',
          varieties: 'Typica, Bourbon, Arusha',
          process: 'Washed, Semi-Washed',
          harvest: 'April – September'
        },
        markerX: 766.6,
        markerY: 554.2
      }
    }
  };
})();
